import { EntDirectoryInfoName } from '../../../../models/directoryInfoName'
import { EntInitialFilterName } from '../../../../models/filters/initialFilterName'
import { ResponseDataGet } from '../../../../models/responseDataGet'
import { agroApi } from '../../api'
import { Paths } from "../../../../paths";

export const questionCategoryApi = agroApi.injectEndpoints({
  endpoints: builder => ({
	getQuestionCategoryList: builder.query<
	  ResponseDataGet<EntDirectoryInfoName>,
	  EntInitialFilterName
	>({
	  query: filter => ({
		url: `${ Paths.handbooks.questionCategoryType }/get-all`,
		method: 'POST',
		body: JSON.stringify(filter),
	  }),
	}),

	getQuestionCategoryById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: id => ({
		url: `${ Paths.handbooks.questionCategoryType }/${ id }`,
		method: 'GET',
	  }),
	}),

	addQuestionCategory: builder.mutation<
	  ResponseDataGet<EntDirectoryInfoName>,
	  EntDirectoryInfoName
	>({
	  query: body => ({
		url: `${ Paths.handbooks.questionCategoryType }`,
		method: 'POST',
		body: JSON.stringify(body),
	  }),
	}),

	editQuestionCategory: builder.mutation<
	  ResponseDataGet<EntDirectoryInfoName>,
	  EntDirectoryInfoName
	>({
	  query: body => ({
		url: `${ Paths.handbooks.questionCategoryType }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteQuestionCategory: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: id => ({
		url: `${ Paths.handbooks.questionCategoryType }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
})

export const {
  useAddQuestionCategoryMutation,
  useDeleteQuestionCategoryMutation,
  useEditQuestionCategoryMutation,
  useLazyGetQuestionCategoryListQuery,
} = questionCategoryApi
